import type { SVGProps } from 'react';

const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3h-8C8.35 3 7 4.35 7 6v1H6c-1.65 0-3 1.35-3 3v8c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3v-1h1c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3m-3 15c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h1v5c0 1.65 1.35 3 3 3h5zm4-4c0 .55-.45 1-1 1h-8c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1z"
    />
  </svg>
);
export default SvgCopy;
